import React, {PropTypes as T} from 'react';
import NormalPriceType from './normal_pricetype';
import PasswrodProtectedPriceType from './password_protected_pricetype';

export default class GAPriceType extends React.Component {
  static propTypes = {
    categoryId:               T.string,
    priceType:                T.object,
    priceFormatted:           T.string,
    eventId:                  T.string,
    price:                    T.object,
    isUnlockingPriceType:     T.oneOfType([T.bool, T.number]),
    totalQuantityInSelection: T.number,
    totalQuantityInSection:   T.number,
    quantityInSelection:      T.number,
    ticketsInBasket:          T.number,
    ticketLimit:              T.number
  };

  render () {
    const { priceType } = this.props;
    const type = priceType.isPasswordProtected ? 'password-protected-gapricetype' : 'gapricetype';

    return (
      <div data-component={type} className="pricetype">
        {
          (priceType.isPasswordProtected && !priceType.isUnlocked)
            ? <PasswrodProtectedPriceType {...this.props} />
            : <NormalPriceType {...this.props} />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gapricetype/index.js